export default __webpack_public_path__ + "static/media/drdong-lg-1x.16dae9b4.jpg";